
















































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import { DataModules } from "@/store/modules/data";
import { IBrand, IObjectNumber } from "@/models/brands";
import { IState } from "@/store";

@Component({
  components: {
    "ticket-departments-contextualise": () =>
      import(
        "@/components/app/admin/settings/brands/tickets/ticketDepartmentsContextualise.vue"
      )
  },
  computed: {
    ...mapState({
      brandId(state: IState) {
        return state.brand.id;
      },
      brandScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/brandScope`](this.brandId);
      },
      brand(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.brandScope
        });
      }
    })
  }
})
export default class BrandTicketsSettings extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Getters
  public brandId!: IBrand["id"];
  public brand!: IBrand;
  public brandScope!: string;

  @Prop({ required: true })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public dynamicSettingsLoading!: boolean;

  public form = {
    brand_id: this.brandId,
    object_type: "Ticket",
    number: 0,
    prefix: ""
  } as IObjectNumber;

  public formClone = this.$_.clone(this.form);
  public objectNumberSettings!: any;

  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  public dataModule: string = DataModules.BRANDS;
  public savedBrandScope!: string;

  public created() {
    if (!this.$userCan("get_brand")) {
      this.isLoading = false;
    }
    this.savedBrandScope = this.brandScope;
    this.loadData();
  }

  public async loadData(ignoreStored = false) {
    try {
      this.objectNumberSettings = await this.getTicketPrefixSettings(
        ignoreStored
      );
      this.fillForm();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getTicketPrefixSettings(ignoreStored = false): Promise<IObjectNumber> {
    return this.$store.dispatch(`data/${DataModules.BRANDS}/getObjectNumber`, {
      ignoreStored,
      vm: this,
      id: this.brandId,
      type: this.form.object_type
    }) as Promise<IObjectNumber>;
  }

  public fillForm() {
    this.form = this.$_.clone(this.objectNumberSettings) as IObjectNumber;
    this.formClone = this.$_.clone(this.form);
  }

  public get formIsValid() {
    return !this.$_.isEqual(this.form, this.formClone);
  }

  public save() {
    return this.updateTicketNumber()
      .then(() => {
        this.formClone = this.$_.clone(this.form);
        this.loadData(true);
        this.$emit("predefinedSettingsAreChanged", false);
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this,
          showToast: false
        });
        throw error;
      });
  }

  public revertToInitialState() {
    this.fillForm();
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.formClone);
  }

  public updateTicketNumber() {
    return this.$store.dispatch(
      `data/${DataModules.BRANDS}/updateObjectNumber`,
      {
        vm: this,
        id: this.brandId,
        type: this.form.object_type,
        data: {
          brand_id: this.brandId,
          object_type: this.form.object_type,
          prefix: this.form.prefix
        }
      }
    );
  }

  @Watch("formIsChanged")
  public onFormIsChanged(isChanged) {
    this.$emit("predefinedSettingsAreChanged", isChanged);
  }

  @Watch("isLoading", { immediate: true })
  public onIsLoadingChange() {
    this.$emit("predefinedSettingsAreLoading", this.isLoading);
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: this.dataModule,
      scope: this.savedBrandScope,
      vm: this
    });
  }
}
